import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'loader',
  imports: [],
  standalone: true,
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  visible = input.required<boolean>()
}
